// Why the bridge ended the chat with a CHAT_ENDED error screen. Picks
// the copy in `chatUnavailableStrings`.
//   out_of_hours    — HOO gate: the chat really is closed
//   auth_ended      — Auth.loggedOut: the member's session ended
//   session_failure — readOnly recovery failed, or session-failure
//                     recurred after an auth redirect
export const CHAT_UNAVAILABLE_REASON = {
  OUT_OF_HOURS: "out_of_hours",
  AUTH_ENDED: "auth_ended",
  SESSION_FAILURE: "session_failure",
} as const;

export type ChatUnavailableReason =
  (typeof CHAT_UNAVAILABLE_REASON)[keyof typeof CHAT_UNAVAILABLE_REASON];
